import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBell,
  faSignOutAlt,
  faQuestionCircle,
  faTrash,
  faSort,
  faTimesCircle,
  faBook,
  faPlusCircle,
  faEdit,
  faUpload,
  faSearch,
  faBars,
  faVideo,
  faFile,
  faPalette,
  faLink,
  faUser,
  faPlay,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faChevronCircleDown,
  faCopy,
  faPaste,
  faListAlt,
  faChartBar,
  faEllipsisH,
  faStop,
  faPause,
  faFlagCheckered,
  faLock,
  faInfoCircle,
  faArrowDown,
  faArrowUp,
  faEye,
  faClock,
  faBan,
  faHandshake,
  faFilePdf,
  faFileCsv,
  faFileExcel,
  faExpand,
  faGrinHearts,
  faGamepad,
  faSync,
  faUnlock,
  faAngleUp,
  faCheckCircle,
  faCircle,
  faCheck,
  faFileExport,
  faExclamationTriangle,
  faKey,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faBell,
  faSignOutAlt,
  faQuestionCircle,
  faTrash,
  faSort,
  faTimesCircle,
  faBook,
  faPlusCircle,
  faEdit,
  faUpload,
  faSearch,
  faBars,
  faVideo,
  faFile,
  faPalette,
  faLink,
  faUser,
  faPlay,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faChevronCircleDown,
  faCopy,
  faPaste,
  faListAlt,
  faChartBar,
  faEllipsisH,
  faStop,
  faPause,
  faFlagCheckered,
  faLock,
  faInfoCircle,
  faArrowDown,
  faArrowUp,
  faEye,
  faClock,
  faBan,
  faHandshake,
  faFilePdf,
  faFileCsv,
  faFileExcel,
  faExpand,
  faGamepad,
  faSync,
  faUnlock,
  faAngleUp,
  faCheckCircle,
  faCircle,
  faCheck,
  faFileExport,
  faExclamationTriangle
);

export const IconType = {
  BELL: faBell.iconName,
  SINGOUT: faSignOutAlt.iconName,
  QUESTION: faQuestionCircle.iconName,
  DELETE: faTrash.iconName,
  SORT: faSort.iconName,
  CLOSE: faTimesCircle.iconName,
  CATALOG: faBook.iconName,
  NEW: faPlusCircle.iconName,
  EDIT: faEdit.iconName,
  UPLOAD: faUpload.iconName,
  SEARCH: faSearch.iconName,
  MENU: faBars.iconName,
  VIDEO: faVideo.iconName,
  FILE: faFile.iconName,
  COLOR: faPalette.iconName,
  LINK: faLink.iconName,
  USER: faUser.iconName,
  PLAY: faPlay.iconName,
  ANGLE_DOWN: faAngleDown.iconName,
  ARROW_LEFT: faAngleLeft.iconName,
  ARROW_RIGHT: faAngleRight.iconName,
  ARROW_UP:faAngleUp.iconName,
  ARROW_DOWN:faAngleDown.iconName,
  CHEVRON_DOWN: faChevronCircleDown.iconName,
  COPY:faCopy.iconName,
  PASTE:faPaste.iconName,
  LOG:faChartBar.iconName,
  ELLIPSIS: faEllipsisH.iconName,
  STOP:faStop.iconName,
  PAUSE:faPause.iconName,
  FINISHED:faFlagCheckered.iconName,
  LOCK:faLock.iconName,
  UNLOCK: faUnlock.iconName,
  INFO:faInfoCircle.iconName,
  IN: faArrowDown.iconName,
  OUT:faArrowUp.iconName,
  VIEW:faEye.iconName,
  CLOCK:faClock.iconName,
  BLACKOUTS:faBan.iconName,
  HANDSHAKE:faHandshake.iconName,
  PDFFILE:faFilePdf.iconName,
  CSVFILE:faFileCsv.iconName,
  EXCELFILE: faFileExcel.iconName,
  EXPAND:faExpand.iconName,
  GAMEPAD: faGamepad.iconName,
  SYNC: faSync.iconName,
  CHECKCIRCLE:faCheckCircle.iconName,
  CHECKBLANK:faCircle.iconName,
  CHECK:faCheck.iconName,
  EXPORT: faFileExport.iconName,
  ALERT: faExclamationTriangle.iconName,
  BLOCK:faBan.iconName,
  UNBLOCK:faKey.iconName,
  '': '',
};

export const IconSize = {
  LARGE: 'lg',
  SMALL: 'sm',
  DOUBLE: '2x',
};

const Icon = (props) => {
  const {
    icon, iconSize, iconColor, className, disabled
  } = props;

  const finalColor = disabled?'#212529':iconColor;
  
  return (
    <FontAwesomeIcon
      className={className}
      icon={icon}
      size={iconSize}
      color={finalColor}
    />
  );
};

Icon.propTypes = {
  icon: PropTypes.oneOf(Object.values(IconType)).isRequired,
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  iconColor: PropTypes.string,
  className: PropTypes.string,
};

Icon.defaultProps = {
  iconSize: IconSize.SMALL,
  iconColor: '',
  className: '',
};

export default Icon;
